<div class="modal-header">
  <h4 class="modal-title" i18n>Select country and language</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body pb-0">
  <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height: 10rem;">
    <div class="spinner-border" role="status"></div>
  </div>
  <table *ngIf="!loading" class="table table-borderless">
    <tr *ngFor="let organization of organizations | localeSort: 'country_local'">
      <td style="width: 4rem;">
        <img [src]="'assets/images/flags/' + organization.country_code.toLocaleLowerCase() + '.webp'" style="height: 4rem; border: none; position: relative; top: -1px;" class="me-1">
      </td>
      <td style="color: #000;">
        <strong style="color: #000;">{{ organization.country_local }}</strong>
        <br>
        <small class="text-muted">{{ organization | translateField: 'country' }}</small>
      </td>
      <td>
        <a (click)="changeLanguage(language, organization.id)" *ngFor="let language of organization.languages.split(',')" class="text-success" href="javascript:void(0)">{{ language | i18nSelect: languages }}</a>
        <a (click)="changeLanguage('en-GB', organization.id)" class="text-success" href="javascript:void(0)">English</a>
      </td>
    </tr>
  </table>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>